import Anchor from './Anchor';

export default Anchor;
export * as AnchorStyles from './Anchor.styles';
export * as AnchorTypes from './Anchor.types';
